export { default as MultiVariantRemovePrompt } from "./MultiVariantRemovePrompt";
export type { IMultiVariantRemovePromptProps } from "./types";
